"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ActionTypes = _interopRequireDefault(require("composer-lib/redux/ActionTypes"));

var _Lock = _interopRequireDefault(require("composer-lib/data/model/Lock"));

var _constants = require("composer-lib/lib/constants");

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _Lock.default();
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.default.ACQUIRE_LOCK:
    case _ActionTypes.default.CLEAR_LOCK:
      return state.set('status', _constants.RequestStatus.PENDING);

    case _ActionTypes.default.ACQUIRE_LOCK_FAILED:
    case _ActionTypes.default.SAVE_COMPOSITION_FAILED_BECAUSE_OF_LOCK:
      {
        var lockedBy = state.lockedBy;

        if (action.data && action.data.data) {
          try {
            var errorData = JSON.parse(action.data.data);
            lockedBy = errorData && errorData.errorTokens && parseInt(errorData.errorTokens.lockedBy[0], 10);
          } catch (e) {// empty (linter complains otherwise)
          }
        }

        return _Lock.default.fromJS({
          lockedBy: lockedBy,
          status: _constants.RequestStatus.FAILED
        });
      }

    case _ActionTypes.default.ACQUIRE_LOCK_SUCCEEDED:
      return action.data;

    case _ActionTypes.default.CLEAR_LOCK_FAILED:
      return state.set('status', _constants.RequestStatus.FAILED);

    case _ActionTypes.default.CLEAR_LOCK_SUCCEEDED:
      return new _Lock.default({
        status: _constants.RequestStatus.SUCCEEDED
      });

    case _ActionTypes.default.LOCK_TOAST_DISMISSED:
      return state.set('toastDismissed', true);

    case _ActionTypes.default.REALTIME_UPDATE_COMPOSITION:
      {
        var _action$data = action.data,
            data = _action$data.data,
            userId = _action$data.userId;
        var authorId = data.authorId;
        var lockedByAnother = userId !== authorId;

        if (lockedByAnother) {
          return _Lock.default.fromJS({
            lockedBy: authorId
          });
        }

        return state;
      }

    case _ActionTypes.default.REALTIME_UPDATE_LOCK:
      return _Lock.default.fromJS(action.data.data.payload);

    default:
      return state;
  }
};

exports.default = _default;
module.exports = exports.default;